var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgThumbUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.667 14.667h2.666v-8H.667v8zm14.666-7.334C15.333 6.6 14.733 6 14 6H9.793l.634-3.047.02-.213c0-.273-.114-.527-.294-.707l-.706-.7L5.06 5.727c-.247.24-.393.573-.393.94v6.666c0 .734.6 1.334 1.333 1.334h6c.553 0 1.027-.334 1.227-.814l2.013-4.7c.06-.153.093-.313.093-.486V7.333z",
    fill: "#4CA375"
  })));
}

export default SvgThumbUp;